import { render, staticRenderFns } from "./PricingSendingInsurancePrimaryLayer.vue?vue&type=template&id=32d210b6"
import script from "./PricingSendingInsurancePrimaryLayer.vue?vue&type=script&lang=js"
export * from "./PricingSendingInsurancePrimaryLayer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports